import { render, staticRenderFns } from "./ChatsMaster.vue?vue&type=template&id=f730f88c"
import script from "./ChatsMaster.vue?vue&type=script&lang=js"
export * from "./ChatsMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports